<template>
    <el-dialog :title="title" :visible.sync="visible" @close="onCance(false)" customClass="customWidth" v-dialogDrag>
    <el-form :model="resourceForm" :rules="rules" ref="resourceForm" label-width="100px" class="dialog-from flex">
        
        <!-- <el-form-item class="item" label="资源类型" prop="resourceType">
          <el-select v-model="resourceForm.resourceTypeTxt" placeholder="请选择" @change="onChangeType">
            <el-option
            v-for="(item,index) in resourceTypes"
            :key="index"
            :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item> -->

        <el-form-item class="item" label="资源类型" prop="resourceType">
          <el-select v-model="resourceForm.resourceType" placeholder="请选择">
            <el-option label="主模块" value="1"></el-option>
            <el-option label="子模块" value="2"></el-option>
            <el-option label="菜单" value="3"></el-option>
            <el-option label="功能" value="4"></el-option>
          </el-select>
        </el-form-item>


        <el-form-item class="item" label="父级资源" prop="parentResourceId">
          <el-select v-model="resourceForm.parentResourceTxt" placeholder="请选择" @change="onChangeParent">
            <el-option label="顶级" value="0"></el-option>
            <template v-for="(item,index) in resourceDataRows"  >
              <el-option v-if="item.resourceId != selectedResource.resourceId" :label="item.value" :value="item.resourceId" :key="item.resourceId"></el-option>
              <template  v-for="(vitem,vindex) in item.children">
                <el-option  v-if="item.children" :label="vitem.value" :value="vitem.resourceId" :key="vitem.resourceId"></el-option>
              </template>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item class="item" label="路由Name" prop="resourceCode">
          <el-input v-model="resourceForm.resourceCode" autocomplete="off" placeholder="用于路由"></el-input>
        </el-form-item>
        <el-form-item class="item" label="资源名称" prop="resourceName">
          <el-input v-model="resourceForm.resourceName" autocomplete="off" placeholder="用于显示"></el-input>
        </el-form-item>
        <el-form-item class="item" label="资源URL" prop="resourceHref">
          <el-input v-model="resourceForm.resourceHref" autocomplete="off" placeholder="连接地址"></el-input>
        </el-form-item>
        <el-form-item class="item" label="资源排序" prop="flag">
          <el-input v-model="resourceForm.sort" autocomplete="off" placeholder="" oninput="value=value.replace('/[\d]/g','')"></el-input>
        </el-form-item>     
        <el-form-item class="item" label="备注" prop="remarks">
          <el-input v-model="resourceForm.remarks" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item class="item" label="资源状态" prop="resourceStatus">
          <el-select v-model="resourceForm.resourceStatus" placeholder="资源状态">
            <el-option label="启用" value="1"></el-option>
            <el-option label="冻结" value="0"></el-option>
          </el-select>
        </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="onCance(false)">取 消</el-button>
      <el-button type="primary" @click.stop="onSubmitResource" v-loading="$store.state.isLoading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
   props:{
      title:{
        type:String,
        default(){
           return 'window title'
        }
      },
      isEditOperate:{
         type:Boolean,
         default(){
           return false;
         }
      },
      parentResources:{
        type:Array,
        default(){
          return []
        }
      },
      // resourceTypes:{
      //   Type:Array,
      //   default(){
      //     return [
      //     {"label":"主模块","value":1},
      //     {"label":"子模块","value":2},
      //     {"label":"菜单","value":3},
      //     {"label":"功能","value":4},
      //   ]}
      // },
      resourceDataRows:{
        Type:Array,
        default(){
          return []
        }
      },
      selectedResource:{
        Type:Object,
        default(){
          return []
        }
      }
    },
    watch:{
        resourceDataset(newVal,oldVal){
          this.resourceDataset=this.resourceDataRows;
        }
    },
    data(){
      return {
        resourceForm:{
          isEdit:false,//状态
        },
        resourceDataset:this.resourceDataRows,
        visible:false,    
        rules:{
          type: [{
            required: true,
            message: '请选择类型',
            trigger: 'change',
          }],
          resourceCode:[{
            required: true,
            message: '请输入路由Name',
            trigger: 'blur',
          }],
          resourceHref:[{
            required: true,
            message: "请输入资源URL",
            trigger: "blur" ,
          }],
          resourceName:[{
            required: true,
            pattern:/^[a-zA-Z0-9_\u4E00-\u9FA5]+$/,
            message: "请输入资源名称",
            trigger: "blur" ,
          }]
        },
      }
    },
    methods:{
      created(){
      },
      onCance(visible){
        let vm=this;
        vm.visible=visible;
        vm.$emit("onCance",visible);
        vm.resetForm();
      },
      // onChangeType(selectedValue){
      //    this.resourceForm["resourceType"]=selectedValue;
      // },
      onChangeParent(){

      },
      showWindow(show){
        this.visible=show;
      },
      /**
       * 重置表单
       */
      resetForm(){
         this.resourceForm={};
      },
      /**
       * 提交资源
       */
      onSubmitResource(){
        let vm = this;       
        vm.$refs['resourceForm'].validate(async (vaild)=>{
          if(vaild){
             vm.$emit('onSubModifyResource',vm.resourceForm);
          }                     
        });
      }
    }
}
</script>